import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ReminderDialogComponent,
  ReminderDialogRef
} from '../shared/reminder-dialog/reminder-dialog.component';
import { ConsoleLogger } from '../shared/console-logger';

@Injectable({
  providedIn: 'root'
})
export class ReminderDialogService {
  private dialogRef?: ReminderDialogRef;

  public isOpen(): boolean {
    return !!this.dialogRef;
  }

  constructor(private readonly dialog: MatDialog) {}

  public open() {
    ConsoleLogger.debug('^^^^ ReminderDialogService - open()');
    if (this.dialogRef) {
      return this.dialogRef.afterClosed();
    }

    this.dialogRef = this.dialog.open(ReminderDialogComponent, {
      disableClose: true,
      panelClass: 'error-dialog',
      maxWidth: '500px',
      minWidth: '500px'
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = void 0;
    });

    return this.dialogRef.afterClosed();
  }

  public close() {
    this.dialogRef?.close();
  }
}
